/**
 * @module __breakPair
 * @since 1.4.0
 */

import { validValue } from '../__validValue';

/**
 * Break a query key=value pair to an array containing key and value respectively
 * @param  {String} item Representation of key value pair 'key=value'
 * @return {Object}
 *
 * @example breakPair('key=value') // {key: 'value'}
 */
export function breakPair(item) {
    const [key, value] = item.split('=');

    return key === '' ? {} : { [key]: validValue(value) };
}
